module.exports = __webpack_public_path__ + "assets/img/MB.873bd8c5.svg";